module.exports = __webpack_public_path__ + "img/businessJieshao.f6152bc6.png";